let kv_1 = [
	{key: "Location", value: "Faridabad"},
	{key: "Phone", value: "+919999306397"},
	{key: "E-mail", value: "jain.lalit138@gmail.com"},
];
let kvs = [kv_1];
let social = {
	github: "https://github.com/lalitjain98",
	// portfolio: "https://lalitjain.me",
	linkedin: "https://www.linkedin.com/in/lalit138/",
	// stopstalk: "https://www.stopstalk.com/user/profile/lalit138",
	// location: "Faridabad",
	// phone: "+919999306397",
	// email: "jain.lalit138@gmail.com"
};
let skills = [
	{
		title: "Worked on",
		data: [
			'HTML',
			'CSS',
			'Javascript',
			'React.js',
			'Redux.js',
			'Node.js',
			// 'Express.js',
			// 'Artificial Intelligence',
			'Sass/Scss',
			// 'Regression/Classification Algorithms',
			// 'Natural Language Processing',
			// 'Neural Networks',
			// 'Android',
			// 'Ruby on Rails'
		]
	},
	{
		title: 'Programming Languages',
		data: [
      'Javascript',
      'C++',
			'Python',
			'Basics of Java'
		]
	}, 
	// {
	// 	title: 'Familiarity with',
	// 	data: [
			// 'jQuery',
			// 'Ajax',
			// 'Java',
			// 'PHP',
			// 'Angular',
			// 'Django',
			// 'Firebase',
			// 'MySQL',
			// 'PostgreSQL',
			// 'MongoDB'
	// 	],
	// },
	{
		title: "Libraries",
		// title: 'Miscelanious',
		data: [
			'Bootstrap',
			'Material UI',
			// 'Materialize CSS',
			// 'Numpy',
			// 'Pandas',
			// 'Matplotlib',
			// 'Scikitlearn',
			// 'Tensorflow',
			// 'Keras'
		]
	}
];
/*
{
		'startDate': '',
		'endDate': '',
		'title': '',
		'subTitle': '',
		'description': ['',]
	},
*/
let education = [
	{
		'startDate': '2016',
		'endDate': '2020',
		'title': 'Bachelor of Technology, Computer Science',
		'subTitle': 'University School Of ICT, Guru Gobind Singh Indraprastha University, New Delhi',
		'description': ['CGPA : 8.05/10']
	},
	{
		'startDate': null,
		'endDate': '2016',
		'title': 'Class XII, Science',
		'subTitle': 'Modern Vidya Niketan School',
		'description': ['Percentage : 90.83%']
	},
	{
		'startDate': null,
		'endDate': '2013',
		'title': 'Class X',
		'subTitle': 'Vidya Sanskar International School',
		'description': ['Percentage : 88.29%']
	},
];
let internships = [
	{
		'isImportant': true,
		'startDate': 'Aug 2019',
		'endDate': 'Apr 2020', //'Aug 2019',
		'title': 'Full Stack Web Developer Intern',
		'subTitle': 'Rydeu',
		'description': [
			'Worked on frontend and backend of the product website using Next.js(React), Redux, Node.js.', 
			// 'Collaborate with the team for building features and functionalities',
			'Initiated the Operations Admin application project using react-admin library.',
		],
		'link_url': 'https://rydeu.com',
		'link_title': '',
	},
	{
		'isImportant': true,
		'startDate': 'Jun 2019',
		'endDate': 'July 2019',
		'title': 'Full Stack Web Developer Intern',
		'subTitle': 'PFRepo Technologies',
		'description': [
			'Worked on the core product to cater to the requirements of partner organizations.',
			'Developed the frontend of the web application using React.js and Redux.',
			'Made use of Node.js for the backend to support the frontend application',
		],
		'link_url': 'https://pfrepo.me/',
		'link_title': '',
	},
	{
		'isImportant': true,
		'startDate': 'Feb 2019',
		'endDate': 'Jun 2019',
		'title': 'Web Developer Intern',
		'subTitle': 'Rydeu',
		'description': [
			'Collaborated with the backend team for building features for the product.'
		],
		'link_url': '',
		'link_title': '',
	},
	{
		'isImportant': true,
		'startDate': 'Aug 2018',
		'endDate': 'Dec 2018',
		'title': 'Teaching Assistant',
		'subTitle': 'Coding Ninjas',
		'description': [
			'Resolved students\' doubts and graded their course projects.'
		],
		'link_url': '',
		'link_title': '',
		// ta stats
		// https://files.codingninjas.in/taship-journey-1314-1602673069-2de2ba42229568a6eb6f4520b8bab86d.jpg
	},
	{
		'isImportant': true,
		'startDate': 'Jun 2018',
		'endDate': 'Jul 2018',
		'title': 'Summer Intern',
		'subTitle': 'Appcode India',
		'description': [
			'Implemented clustering algorithms using Python',
			'Research on ways to implement targeted advertising'
		],
		'link_url': '',
		'link_title': '',
		// 'description': [
		// 	'Worked on Clustering Techniques to make comparisons about the use cases in which one technique might perform better.',
		// 	'Researched several tools and techniques used for Natural Language Processing', 
		// 	'Also dug deeper for ways to implement targeted advertising in the client\'s mobile and web applications.'
		// ],
	},
	{
		'isImportant': false,
		'startDate': 'Jan 2018',
		'endDate': 'Feb 2018',
		'title': 'Android and PHP Developer Intern',
		'subTitle': 'Swar Yantra Technologies',
		'description': [
			'Worked on full-stack Android application development.',
			'Used core PHP and MySQL in the backend to support the frontend.',
			'Developed two android applications during the course of the internship.'
		],
		'link_url': '',
		'link_title': '',
	},
];
let projects = [
	{
		'isImportant': true,
		'imgSrc': '/assets/images/projects/food-shala.png',
		'startDate': null,
		'endDate': 'May 2020',
		'title': 'Food Shala',
		'subTitle': 'Python Django',
		'description': [
			// 'Customers and Restaurants can register themselves into the system.',
			'Developed a basic online food ordering application.',
			'Using the web app, customers can browse the menu and order food items.',
			'Restaurants can update their menu and view incoming orders.',
		],
		'link_url': 'http://ec2-18-224-4-9.us-east-2.compute.amazonaws.com',
		'link_title': 'App Link',
		// 'project_link': 'http://ec2-18-224-4-9.us-east-2.compute.amazonaws.com',
		// 'https://github.com/lalitjain98/food-shala'
	},
	{
		'isImportant': true,
		'imgSrc': '/assets/images/projects/smart-resume-app.png',
		'startDate': null,
		'endDate': 'May 2020',
		'title': 'Smart Resume Application',
		'subTitle': 'React/Node',
		'description': [
			'Users can build and update their resumes conveniently.',
			'Functionality to add any number of sections with customised titles.',
			'Each experience item can have a link with custom link text.',
		],
		'link_url': 'https://github.com/lalitjain98/smart-resume-app',
		'link_title': 'Repo',
		// 'project_link': 'https://github.com/lalitjain98/smart-resume-app'
	},
	{
		'isImportant': true,
		'imgSrc': '/assets/images/projects/node-task-manager-app.png',
		'startDate': null,
		'endDate': 'July 2019',
		'title': 'Task Manager',
		'subTitle': 'Node/Express',
		'description': [
			'Keep track of pending activities.',
			'Feature to sort Items by due date or title.',
			'User can group list items by labels.',
		],
		'link_url': 'https://lalits-node-task-manager.herokuapp.com',
		'link_title': 'App Link',
		// 'project_link': 'https://github.com/lalitjain98/node-todo-app'
	},
	{
		'isImportant': false,
		'imgSrc': '/assets/images/projects/pomodoro-clock.jpg',
		'startDate': null,
		'endDate': 'Mar 2019',
		'title': 'Pomodoro Clock',
		'subTitle': 'ReactJS',
		'description': [
			// 'Minor project developed using ReactJS',
			// 'Useful for better Time Management with builtin alarm beep'
		],
		'link_url': 'https://lalitjain98.github.io/pomodoro-clock/',
		'link_title': 'App Link',
		// 'project_link': 'https://lalitjain98.github.io/pomodoro-clock/'
	},
	{
		'isImportant': false,
		'imgSrc': '/assets/images/projects/drum-machine.jpg',
		'startDate': null,
		'endDate': 'Mar 2019',
		'title': 'Drum Machine',
		'subTitle': 'ReactJS',
		'description': [

		],
		'link_url': 'https://lalitjain98.github.io/drum-machine',
		'link_title': 'Link',
		// 'project_link': 'https://lalitjain98.github.io/drum-machine'
	},
	{
		'isImportant': false,
		'imgSrc': '/assets/images/projects/js-calculator.jpg',
		'startDate': null,
		'endDate': 'Mar 2019',
		'title': 'Javascript Calculator',
		'subTitle': 'ReactJS',
		'description': [

		],
		'link_url': 'https://lalitjain98.github.io/js-calculator/',
		'link_title': 'Link',
		// 'project_link': 'https://lalitjain98.github.io/js-calculator/'
	},
	{
		'isImportant': false,
		'imgSrc': '/assets/images/projects/markdown-previewer.jpg',
		'startDate': null,
		'endDate': 'Mar 2019',
		'title': 'Markdown Previewer',
		'subTitle': 'ReactJS',
		'description': [
			'Powered by MarkedJS'
		],
		'link_url': 'https://lalitjain98.github.io/markdown-previewer/',
		'link_title': 'Link',
		// 'project_link': 'https://lalitjain98.github.io/markdown-previewer/'
	},
	{
		'isImportant': false,
		'imgSrc': '/assets/images/projects/random-quote-generator.jpg',
		'startDate': null,
		'endDate': 'Jan 2019',
		'title': 'Random Quote Generator',
		'subTitle': 'ReactJS',
		'description': [
			// 'First Project developed using React',
			// 'Motivates the user with randomly picked quotes',
			// 'Allows the user to tweet a quote worth sharing'
		],
		'link_url': 'https://lalitjain98.github.io/random-quote-generator/',
		'link_title': 'Link',
		// 'project_link': 'https://lalitjain98.github.io/random-quote-generator/'
	},
	{
		'isImportant': false,
		'imgSrc': '/assets/images/projects/decision-tree.jpg',
		'startDate': null,
		'endDate': 'Jun 2018',
		'title': 'Decision Tree Classifier Implementation',
		'subTitle': 'Machine Learning',
		'description': [
			'Visualized the model using graphs for analyzing the predictions.',
			'Drew a decision tree for the trained classifier using Pydotplus library.',
			// 'Achieved an F1 Score of 0.92/1.0 for Iris Dataset.',
		],
		'link_url': 'https://github.com/lalitjain98/machine-learning-june-18/blob/master/14.%20Decision%20Trees/Decision%20Tree%20Implementation%20Project.ipynb',
		'link_title': 'Repo',
		// 'project_link': 'https://github.com/lalitjain98/machine-learning-june-18/blob/master/14.%20Decision%20Trees/Decision%20Tree%20Implementation%20Project.ipynb'
	},
	{
		'isImportant': true,
		'imgSrc': '/assets/images/projects/multinomial-naive-bayes.jpg',
		'startDate': null,
		'endDate': 'Jul 2018',
		'title': 'Text Classification',
		'subTitle': 'Machine Learning',
		'description': [
			'Implemented the Naive Bayes algorithm in Python using Numpy.',
			// 'Performed data preprocessing and converted unstructured text documents into numeric representation.',
			// 'Achieved an F1 Score of 0.89/1.0 using all words as features',
		],
		'link_url': 'https://github.com/lalitjain98/machine-learning-june-18/blob/master/16.%20Text%20Classification%20Project/Final%20Project/Text%20Classification%20Project%20Complete%20v1%20min%20word%20count%2015.ipynb',
		'link_title': 'Repo',
		// 'project_link': 'https://github.com/lalitjain98/machine-learning-june-18/blob/master/16.%20Text%20Classification%20Project/Final%20Project/Text%20Classification%20Project%20Complete%20v1%20min%20word%20count%2015.ipynb'
	},
	{
		'isImportant': false,
		'imgSrc': '/assets/images/projects/movie-guide.png',
		'startDate': 'Oct 2017',
		'endDate': 'Nov 2017',
		'title': 'Movie Guide',
		'subTitle': 'Android',
		'description': [
			'Using API by themoviedb.org', 
			'Along with movies, this app also provides information about TV Shows.', 
			'The user can also bookmark favorite movies and TV shows'
		],
		'link_url': 'https://github.com/lalitjain98/MovieGuide',
		'link_title': 'Repo',
		// 'project_link': 'https://github.com/lalitjain98/MovieGuide'
	},
	// {
	// 	'isImportant': false,
	// 	// 'imgSrc': '/assets/images/projects/todo-application.jpg',
	// 	'startDate': null,
	// 	'endDate': 'Oct 2017',
	// 	'title': 'Todo Application',
	// 	'subTitle': 'Android',
	// 	'description': ['TODO Application with reminders if required by the user in the form of notification.'],
	// 	'link_url': 'https://github.com/lalitjain98/TODO',
	// 	'link_title': 'Repo',
	// 	// 'project_link': 'https://github.com/lalitjain98/TODO'
	// },
	// {
	// 	'isImportant': false,
	// 	// 'imgSrc': '/assets/images/projects/minesweeper-game.jpg',
	// 	'startDate': null,
	// 	'endDate': 'Sep 2017',
	// 	'title': 'Minesweeper Game',
	// 	'subTitle': 'Android',
	// 	'description': [
	// 		// 'The classic Minesweeper game.', 
	// 		// 'The user can also add Player Name and change level of difficulty.'
	// 	],
	// 	'link_url': 'https://github.com/lalitjain98/Minesweeper',
	// 	'link_title': 'Repo',
	// 	// 'project_link': 'https://github.com/lalitjain98/Minesweeper'
	// },
	// {
	// 	'startDate': '',
	// 	'endDate': '',
	// 	'title': '',
	// 	'subTitle': '',
	// 	'description': ['',],
	// 	'project_link': ''
	// },
];
let courses = [
	// {
	// 	'startDate': null,
	// 	'endDate': 'Feb 2019',
	// 	'title': 'Deep Learning',
	// 	'subTitle': 'Coursera Specialization',
	// 	'description': [],
	// 	'certificate_link': 'https://www.coursera.org/account/accomplishments/specialization/GSUVDNVAE3S4'
	// },
	{
		'startDate': null,
		'endDate': 'Jan 2019',
		'title': 'ReactJS',
		'subTitle': 'Coursera Specialization',
		'description': [],
		'link_url': 'https://www.coursera.org/account/accomplishments/specialization/BARBSGQBHBHL',
		'link_title': 'Certificate',
		// 'certificate_link': 'https://www.coursera.org/account/accomplishments/specialization/BARBSGQBHBHL'
	},
	// {
	// 	'startDate': null,
	// 	'endDate': 'Dec 2018',
	// 	'title': 'Responsive Web Design',
	// 	'subTitle': 'Free Code Camp',
	// 	'description': [],
		// 'link_url': 'https://www.freecodecamp.org/certification/lalitjain98/responsive-web-design',
		// 'link_title': 'Certificate',
	// 	'certificate_link': 'https://www.freecodecamp.org/certification/lalitjain98/responsive-web-design'
	// },
	// {
	// 	'startDate': 'Jun 2018',
	// 	'endDate': 'Jul 2018',
	// 	'title': 'Full Stack Web Development',
	// 	'subTitle': 'Coding Ninjas',
	// 	'description': [],
		// 'link_url': 'https://ninjasfiles.s3.amazonaws.com/certificate227588f3373c041c3c031ce417a9701050c87b.pdf',
		// 'link_title': 'Certificate',
	// 	'certificate_link': 'https://ninjasfiles.s3.amazonaws.com/certificate227588f3373c041c3c031ce417a9701050c87b.pdf'
	// },
	{
		'startDate': 'Jun 2018',
		'endDate': 'Jul 2018',
		'title': 'Machine Learning',
		'subTitle': 'Coding Ninjas',
		'description': [],
		'link_url': 'https://ninjasfiles.s3.amazonaws.com/certificate222473360310e5067defa6fa806647f838699.pdf',
		'link_title': 'Certificate',
		'certificate_link': 'https://ninjasfiles.s3.amazonaws.com/certificate222473360310e5067defa6fa806647f838699.pdf'
	},
	// {
	// 	'startDate': 'Aug 2017',
	// 	'endDate': 'Nov 2017',
	// 	'title': 'Android Development',
	// 	'subTitle': 'Coding Ninjas',
	// 	'description': [],
			// 'link_url': '',
			// 'link_title': '',
	// 	'certificate_link': null
	// },
	{
		'startDate': 'Aug 2016',
		'endDate': 'Nov 2016',
		'title': 'Data Structures using C++',
		'subTitle': 'Coding Ninjas',
		'description': [],
		'link_url': '',
		'link_title': '',
		'certificate_link': null
	},
	// {
	// 	'startDate': '',
	// 	'endDate': '',
	// 	'title': '',
	// 	'subTitle': '',
	// 	'description': '',
			// 'link_url': '',
			// 'link_title': '',
	// 	'certificate_link': ''
	// },
];

export const data = {
	title: "Lalit Jain",
	subtitle: "Software Developer",
	// subtitle: "Final Year Student",
	stopstalk: "https://www.stopstalk.com/user/profile/lalit138",
	social: social,
	kvs: kvs,
	skills: skills,
	education: education,
	internships: internships,
	projects: projects,
	courses: courses
};